import React from 'react';
import HomePageImg from '../imgs/homepage.jpg';
import Landscape1 from "../imgs/landscape1.jpg";
import Landscape2 from "../imgs/landscape2.jpg"
import Tree1 from "../imgs/icetree1.jpg"
import Tree2 from "../imgs/icetree2.jpg"
import Tree3 from "../imgs/icetree3.jpg"
import { Link } from 'react-router-dom';

const Home: React.FC = () => {
  return (
    <div className="relative flex flex-col items-center">
      

      <div className="relative w-full flex items-center justify-center z-0">
        <div className="absolute inset-0 bg-tan bg-opacity-50"></div>
        <div className="hidden md:block w-1/4 h-screen">
          <img
            src={Landscape1}
            alt="Flower Left"
            className="w-full h-full object-cover"
          />
        </div>

        <div
          className="w-full md:w-1/2 h-screen relative bg-cover bg-center"
          style={{ backgroundImage: `url(${HomePageImg})` }}
        >


          <div className="absolute inset-0 bg-tan bg-opacity-50 z-10 pointer-events-none"></div>

          <div className="absolute inset-0 flex items-center justify-center text-greentext z-20 drop-shadow-sm">
            <h1 className="text-5xl font-bold drop-shadow-lg text-center">
              Embrace Your Life.
            </h1>
          </div>
        </div>

        <div className="hidden md:block w-1/4 h-screen">
          <img
            src={Landscape2}
            alt="Flower Right"
            className="w-full h-full object-cover"
          />
        </div>
      </div>

      <div className="w-full h-80 bg-tanbg py-12 z-20 relative">
        <div className="max-w-7xl mx-auto px-8 flex justify-center items-center">
          <div className="flex-1 flex justify-center">
          <a
            href="https://calendly.com/seanmotiv8living"
            className="text-greentext font-semibold text-2xl hover:text-greenbutton transition"
          >
            Sign Up Now
          </a>
          </div>

          <div className="mx-24 h-60 border-l border-greentext"></div>

          <div className="flex-1 flex justify-center">
            <Link to="/contact" className="text-greentext font-semibold text-2xl hover:text-greenbutton transition">
              Contact Us
            </Link>
          </div>
        </div>
      </div>
      <div className="w-screen bg-lighttan">
        <div className="grid grid-cols-3 relative">
          {/* Photo 1 */}
          <div className="relative">
            <img
              src={Tree1}
              alt="Description 1"
              className="w-full h-full object-cover"
            />
            <div className="absolute inset-0 bg-tantext opacity-30"></div>
          </div>

          {/* Photo 2 */}
          <div className="relative">
            <img
              src={Tree2}
              alt="Description 2"
              className="w-full h-full object-cover"
            />
            <div className="absolute inset-0 bg-tantext opacity-30"></div>
          </div>

          {/* Photo 3 */}
          <div className="relative">
            <img
              src={Tree3}
              alt="Description 3"
              className="w-full h-full object-cover"
            />
            <div className="absolute inset-0 bg-tantext opacity-30"></div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Home;
